import { useState, useEffect } from 'react';
import { loadOrgCurrency, DEFAULT_CURRENCY } from '../utils/currency';

export function useOrgCurrency(): string {
  const [currency, setCurrency] = useState(DEFAULT_CURRENCY);
  useEffect(() => {
    loadOrgCurrency().then(setCurrency);
  }, []);
  return currency;
}
